module.exports = __webpack_public_path__ + "static/timeline3-dff78a9d725058dfbafb08d60871b487.png";